import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { FolderDraftEmailsChangeEvent } from 'src/app/models/events/folder-draft-emails-change-event';

@Injectable({
    providedIn: 'root',
})
export class FolderDraftEmailsStateService {
    private onFolderDraftEmailChange = new BehaviorSubject<FolderDraftEmailsChangeEvent>(null);

    /**
     * Emet un événement lorsque les brouillons d'un dossier change.
     */
    get onFolderDraftEmailChange$() {
        return this.onFolderDraftEmailChange.asObservable();
    }

    /**
     * Indique que les brouillons d'un dossier ont été mis à jour.
     */
    public updateFolderDraftEmailChange(event: FolderDraftEmailsChangeEvent) {
        this.onFolderDraftEmailChange.next(event);
    }

    constructor() {}
}
